<template>
  <div class="wrap"></div>
</template>

<script>
import types from "@/store/types";
import api from "@/utils/api";

export default {
  name: "OrderPay",
  created() {
    let { sn, m, t } = this.$route.query;
    if (sn && m && t) {
      this.toPayOrder(sn, m, t);
    }
  },
  methods: {
    toPayOrder(sn, m, t) {
      api[types.ORDER_PAY]({
        order_sn: sn,
        payment_method: m,
        trade_type: t
      }).then(res => {
        if (res.code == 1) {
          document.documentElement.innerHTML = res.data;
          document.SendOrder?.submit();
        } else if (res.code != 2) {
          this.$message({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.log(err);
      })
    }
  }
}
</script>

<style>

</style>